import { HttpError, IHttpClient } from '../core/services/httpClient'

export type FavoriteMessageRequest = {
  messageId: string
  conversationId: string
  tenantId: string
  email?: string
}

export class MaxFavoriteService {
  constructor(private readonly httpClient: IHttpClient) {}

  favoriteMessage(payload: FavoriteMessageRequest): Promise<void> {
    return this.submit('/fav', payload, 'Failed to favorite message')
  }

  unfavoriteMessage(payload: FavoriteMessageRequest): Promise<void> {
    return this.submit('/unfav', payload, 'Failed to unfavorite message')
  }

  private async submit(
    endpoint: '/fav' | '/unfav',
    payload: FavoriteMessageRequest,
    context: string
  ): Promise<void> {
    try {
      if (!payload.messageId.trim()) {
        throw new Error('Message ID is required')
      }
      if (!payload.conversationId.trim()) {
        throw new Error('Conversation ID is required')
      }
      if (!payload.tenantId.trim()) {
        throw new Error('Tenant ID is required')
      }

      await this.httpClient.post(endpoint, {
        tenantId: payload.tenantId,
        messageId: payload.messageId,
        conversationId: payload.conversationId,
        email: payload.email || undefined,
      })
    } catch (error) {
      throw this.handleError(error, context)
    }
  }

  private handleError(error: unknown, context: string): Error {
    if (error instanceof HttpError) {
      if (error.status === 401) return new Error('Unauthorized - Please log in again')
      if (error.status === 403) return new Error('Access denied - You do not have permission')
      if (error.status === 404) return new Error('Message not found')
      if (error.status >= 500) return new Error('Server error - Please try again later')
      return new Error(`${context}: ${error.message}`)
    }

    if (error instanceof Error) {
      return error
    }

    return new Error(context)
  }
}
